import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchOrdersApi } from "../../services/OrderApi";
import cogoToast from "cogo-toast";
import { store } from "../../store/store";
import { setlineItem } from "../../store/slices/lineitemadded-slice";
import { setlogouttoggle } from "../../store/slices/logouttoggle-slice";
import { clearAccessToken } from "../../store/slices/authSlice";

const AuthWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accessToken = useSelector((state) => state.accessToken.token);
  const expiresAt = useSelector((state) => state.accessToken.expiresAt);

  useEffect(() => {
    const fetchOrders = async () => {
      const result = await fetchOrdersApi(accessToken);
      if (result === "Unauthorized") {
        logoutUser();
      }
    };

    if (accessToken) {
      fetchOrders();
    }
  }, [location]);

  useEffect(() => {
    if (expiresAt) {
      const interval = setInterval(() => {
        const currentTime = new Date().toISOString();
        const sanitizedExpiresAt = expiresAt.split(".")[0] + "Z"; // Remove nanoseconds
        if (currentTime >= sanitizedExpiresAt) {
          logoutUser();
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [expiresAt]);

  const logoutUser = () => {
    store.dispatch(clearAccessToken());
    store.dispatch(setlineItem(true));
    store.dispatch(setlogouttoggle(true));
    navigate("/login-register");
    cogoToast.error("Session expired. Please log in again.", {
      position: "bottom-left",
    });
  };

  return (
    <div className="">
      <Outlet />
    </div>
  );
};

export default AuthWrapper;
